'use client';
import { FC, PropsWithChildren } from 'react';
import { CatSearchForm } from '@blocks-react/components/SearchForm';
import { useController, useFormContext } from 'react-hook-form';
import { MyEquipmentSearchFormProps } from '../types';
import styles from '../MyEquipment.module.scss';

export const MyEquipmentSearchForm: FC<
  PropsWithChildren<MyEquipmentSearchFormProps>
> = ({
  children,
  placeholder,
  maxLength,
  onSearch,
  onSearchClose,
  rules = {},
  name,
  classname,
  isEmpty = false,
  isError,
  showDuplicateEquipmentError,
  onBlMobileOverlayOpen,
  onBlMobileOverlayClose,
  dataCsMask,
  mobileBreakPoint = 560
}) => {
  const { control, setValue, getValues } = useFormContext();
  const { field, fieldState } = useController({ name, control, rules });

  const error = !!(isError ?? fieldState.error) || showDuplicateEquipmentError;
  const onMobileOverlayOpen = () => {
    if (onBlMobileOverlayOpen) {
      onBlMobileOverlayOpen();
    }
  };

  const onMobileOverlayClose = () => {
    if (onBlMobileOverlayClose) {
      onBlMobileOverlayClose();
    }
  };

  return (
    // TODO - Input Validation - Ensure that <,>,/,\ characters and <script> tags are not allowed to type/paste.
    // TODO - Input Validation - Ensure that maximum query params length is 1024 characters
    <CatSearchForm
      size="md"
      placeholder={placeholder}
      className={`${styles['searh-form-overlay']} ${classname}`}
      status={error ? 'error' : undefined}
      maxlength={maxLength}
      data-testid="searchForm"
      value={getValues(name)}
      onBlChange={(e) => {
        setValue(name, e.detail.value ?? '');
        onSearch(e.detail.value ?? '');
        field.onChange(e);
      }}
      onBlSearchClose={(e: Event) => {
        e.stopPropagation();
        if (onSearchClose) {
          onSearchClose();
        }
      }}
      onBlur={() => field.onBlur()}
      isEmpty={isEmpty}
      onBlMobileOverlayOpen={onMobileOverlayOpen}
      onBlMobileOverlayClose={onMobileOverlayClose}
      data-cs-mask={dataCsMask}
      mobileBreakPoint={mobileBreakPoint}
    >
      {children}
    </CatSearchForm>
  );
};
